const queryString = require('query-string');
require('jquery/dist/jquery.min');

$(function () {

  if ($('#updateNotificationGroups').length > 0) {

    // Disable auto-complete on Firefox
    $(":checkbox").attr("autocomplete", "off");

    // Keep a reference of this DOM elements.
    var $emailField = $('#inputMemberEmail');
    var $emailFieldConfirmation = $('#inputMemberEmailConfirmation');

    // Make e-mail field mandatory if "ablApplicationCommunicationByMail" or "ablMagazineByMail" is already active.
    if (AblChNotificationGroupPlugin.selectedGroups.indexOf('ablApplicationCommunicationByMail') > -1 || AblChNotificationGroupPlugin.selectedGroups.indexOf('ablMagazineByMail') > -1) {
      // inputMemberEmail must be required
      $emailField.prop('required', true);
    }

    /**
     * Add listener when checkbox "ablApplicationCommunicationByMail" changes => we must toggle $emailField required property
     */
    $('#notificationGroup-ablApplicationCommunicationByMail, #notificationGroup-ablMagazineByMail').change(function (e) {
      if($(e.target).is(':checked')) {
            $emailField.prop('required', true);
            $emailFieldConfirmation.prop('required', true)
      }
      else {
        $emailField.prop('required', false);
        $emailFieldConfirmation.prop('required', false);
      }
      // We trigger input to notify parsley of this change
      $emailField.trigger('input');
      $emailFieldConfirmation.trigger('input');
    });

    // inputMemberEmailConfimation must be required on changes in field
    $emailField.bind('change',function (e) {
      if($emailField.val() != ''){
        $emailField.prop('required', true);
        $emailFieldConfirmation.prop('required', true);
      }
      else {
        $emailField.prop('required', true);
        $emailFieldConfirmation.prop('required', false);
      }
    });

    $('#updateNotificationGroups').parsley();

    /*
     * Check if the page was loaded after creating an application
     * If so, check if the person *doesn't wish* to receive application communication by mail
     * If so, ask them if they want it in the future
     */
    const $ablApplicationCommunicationByMailCheckbox = $('#notificationGroup-ablApplicationCommunicationByMail');
    const $askForAblApplicationCommunicationByMailModal = $('#askForAblApplicationCommunicationByMailModal');
    const $askForAblApplicationCommunicationByMailForm = $('#askForAblApplicationCommunicationByMailForm');
    const queryStrings = queryString.parse(location.search);
    if ('applicationCreated' in queryStrings) {
      let hasAblApplicationCommunicationByMail = $ablApplicationCommunicationByMailCheckbox.prop('checked');
      if (!hasAblApplicationCommunicationByMail) {
        // Copy the current e-mail from the form
        $askForAblApplicationCommunicationByMailModal.find('#modalEmail').val($('#inputMemberEmail').val());
        // Initialize parsley for the form
        $askForAblApplicationCommunicationByMailForm.parsley();
        // Open the modal
        $askForAblApplicationCommunicationByMailModal.modal();
      }
    }

    /*
      If they agree, set the checkbox in the according form and try to submit
     */
    $('body').on('click', '#receiveAblApplicationCommunicationByMailModal', function () {
      let formValidationSuccessful = $askForAblApplicationCommunicationByMailForm.parsley().validate();
      if (formValidationSuccessful) {
        $ablApplicationCommunicationByMailCheckbox.prop('checked', true);
        $askForAblApplicationCommunicationByMailModal.modal('hide');
        const $updateNotificationSettingsForm = $ablApplicationCommunicationByMailCheckbox.closest('form');
        // Copy the (possibly) updated e-mail to the form
        $updateNotificationSettingsForm.find('#inputMemberEmail').val($('#modalEmail').val());
        $updateNotificationSettingsForm.submit();
      }
    });

  }
});
